module.exports = __webpack_public_path__ + "img/03.b08d1f8a.jpg";